import React, { useRef, useState, useCallback } from "react";

export const BeforeAfterSlider = ({ before, after, beforeAlt = "Before", afterAlt = "After", height = "h-[420px]" }) => {
  const ref = useRef(null);
  const [pos, setPos] = useState(50);
  const dragging = useRef(false);

  const move = useCallback((clientX) => {
    const el = ref.current;
    if (!el) return;
    const rect = el.getBoundingClientRect();
    const p = ((clientX - rect.left) / rect.width) * 100;
    setPos(Math.max(0, Math.min(100, p)));
  }, []);

  const onDown = (e) => { dragging.current = true; move(e.clientX ?? e.touches?.[0]?.clientX); };
  const onMove = (e) => { if (dragging.current) move(e.clientX ?? e.touches?.[0]?.clientX); };
  const onUp = () => { dragging.current = false; };

  return (
    <div
      ref={ref}
      data-testid="before-after-slider"
      className={`relative w-full ${height} overflow-hidden rounded-2xl select-none cursor-ew-resize border border-rossi-gold/20`}
      onMouseDown={onDown} onMouseMove={onMove} onMouseUp={onUp} onMouseLeave={onUp}
      onTouchStart={onDown} onTouchMove={onMove} onTouchEnd={onUp}
    >
      <img src={after} alt={afterAlt} className="absolute inset-0 w-full h-full object-cover" draggable={false} />
      <div className="absolute inset-0 overflow-hidden" style={{ width: `${pos}%` }}>
        <img src={before} alt={beforeAlt} className="absolute inset-0 h-full object-cover"
             style={{ width: ref.current ? ref.current.offsetWidth : "100%", maxWidth: "none" }} draggable={false} />
        <span className="absolute top-4 left-4 text-[11px] font-mono uppercase tracking-widest bg-rossi-bg/70 text-rossi-cream px-3 py-1 rounded-full">Before</span>
      </div>
      <span className="absolute top-4 right-4 text-[11px] font-mono uppercase tracking-widest bg-rossi-gold text-rossi-bg px-3 py-1 rounded-full">After</span>
      <div className="absolute top-0 bottom-0 w-[2px] bg-rossi-gold" style={{ left: `${pos}%` }}>
        <div className="absolute top-1/2 -translate-y-1/2 -translate-x-1/2 h-10 w-10 rounded-full bg-rossi-gold text-rossi-bg flex items-center justify-center shadow-lg">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><path d="M8 7l-5 5 5 5M16 7l5 5-5 5" /></svg>
        </div>
      </div>
    </div>
  );
};

export default BeforeAfterSlider;
